import { patientDetails } from './details';

export const patientFields = {
    ...patientDetails,
};
